module.exports = __webpack_public_path__ + "img/ss-border.3f69b480.svg";